'use client'

import { Box } from '@mui/material'
import { SwiperSlide } from 'swiper/react'
import {
  PreviewCard,
  PreviewCardData,
  SectionHeader,
  SectionHeaderData,
  SectionWrapper,
} from '@components/common'
import { getStyles } from '@utils/styles'
import { CarouselSection } from '../CarouselSection'
import defaultStyles from './styles'
import type { SwiperOptions } from 'swiper/types'

export type OurPortfolioSectionData = {
  sectionHeaderData?: SectionHeaderData
  previewCardData?: PreviewCardData[]
}

type OurPortfolioSectionProps = OurPortfolioSectionData & {
  swiperOptions: SwiperOptions
  compact?: boolean
}

export function OurPortfolioSection({
  sectionHeaderData,
  previewCardData,
  compact,
}: OurPortfolioSectionProps) {
  const styles = getStyles(defaultStyles)

  return (
    <SectionWrapper
      flexCol={{ xs: '20px', md: '32px' }}
      {...styles('wrapper')}
      compact={compact}
    >
      {sectionHeaderData && <SectionHeader {...sectionHeaderData} compact />}
      <CarouselSection
        swiperOptions="autoSlideView"
        disableArrow={(previewCardData?.length ?? 0) < 3}
      >
        {!!previewCardData?.length && (
          <Box {...styles('cardWrapper')} className="outPortfolioCarousel">
            {previewCardData.map((item, idx) => (
              <SwiperSlide key={`${idx}-${item.title}`}>
                <PreviewCard
                  {...item}
                  key={idx}
                  csx={{
                    wrapper: {
                      width: {
                        xs: '98%',
                        md: '100%',
                      },
                    },
                  }}
                />
              </SwiperSlide>
            ))}
          </Box>
        )}
      </CarouselSection>
    </SectionWrapper>
  )
}
